import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./events.css";

const CheckInPage = lazy(() => import("./check-in").then((m) => ({ default: m.CheckInPage })));
const EventPage = lazy(() => import("./event-page").then((m) => ({ default: m.EventPage })));
const EventsListPage = lazy(() => import("./list").then((m) => ({ default: m.EventsListPage })));
const EventsSettingsSection = lazy(() => import("./settings").then((m) => ({ default: m.EventsSettingsSection })));
const EventSetupPage = lazy(() => import("./setup").then((m) => ({ default: m.EventSetupPage })));
const GuidedSetupPage = lazy(() => import("./guided").then((m) => ({ default: m.GuidedSetupPage })));

/** The Events solution's admin: the list, each event's page, its setup (and Guided setup, full screen), check-in at the door, and its settings. */

export const routes: SolutionRoute[] = [
  { solution: "events", path: "events", element: <EventsListPage /> },
  { solution: "events", path: "events/:id", element: <EventPage /> },
  { solution: "events", path: "events/:id/setup", element: <EventSetupPage /> },
  { solution: "events", path: "events/:id/guided", element: <GuidedSetupPage />, bare: true },
  { solution: "events", path: "check-in", element: <CheckInPage />, bare: true },
];

export const settings: SolutionSettings[] = [{ solution: "events", key: "events", label: "Events", icon: Icon.run, need: "events.view", Component: EventsSettingsSection }];

export const nav: NavItem = {
  to: "/events",
  label: "Events",
  icon: Icon.run,
  solution: "events",
  need: "events.view",
  also: ["/check-in"],
  subs: [{ to: "/check-in", label: "Check-in" }],
};
